import { cn } from '@/lib/utils';

/**
 * The wordmark, from the same asset the existing dashboard uses.
 * Intrinsic size 3128×938; the width classes below preserve that ratio.
 */
export function TollitLogo({ className }: { className?: string }) {
  return (
    <img
      src="/brand/tollit-logo-white.png"
      alt="Tollit"
      width={3128}
      height={938}
      className={cn('h-auto w-[110px] select-none', className)}
      draggable={false}
    />
  );
}
